"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _colors = require("HubStyleTokens/colors");

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UsageTracker = require("MeetingsLib/tracking/UsageTracker");

var _getFreemiumViralLink = _interopRequireDefault(require("MeetingsLib/components/freemium/getFreemiumViralLink"));

var _paths = require("MeetingsLib/constants/paths");

var FreemiumBookingUpgradeLink = (0, _createReactClass.default)({
  displayName: "FreemiumBookingUpgradeLink",
  goToMeetingsPage: function goToMeetingsPage(viralLink) {
    (0, _UsageTracker.track)('meetingsLibClickPromoLink', {
      page: 'booking'
    });
    window.open(viralLink, '_blank');
  },
  renderUpgradeLink: function renderUpgradeLink() {
    var _this = this;

    var embedded = this.props.embedded;
    var viralLink = (0, _getFreemiumViralLink.default)(_paths.BOOKING_VIRAL_HUBS_CTA, this.props.portalId, embedded);
    return _react.default.createElement(_UIButton.default, {
      style: {
        width: 'inherit'
      },
      use: "link",
      onClick: function onClick() {
        _this.goToMeetingsPage(viralLink);
      }
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "prebook.freemium.linkText"
    }));
  },
  render: function render() {
    var embedded = this.props.embedded;
    var verticalPadding = embedded ? 'p-y-2' : 'p-y-3';
    return _react.default.createElement("div", {
      className: "text-center date-picker-freemium-cta " + verticalPadding,
      style: {
        color: _colors.EERIE
      }
    }, _react.default.createElement(_UIIcon.default, {
      name: "sprocket",
      color: _colors.LORAX,
      className: "m-right-1"
    }), _react.default.createElement(_FormattedReactMessage.default, {
      message: "prebook.freemium.ctaText",
      options: {
        linkText: this.renderUpgradeLink()
      }
    }));
  }
});

var _default = (0, _reactRedux.connect)(function (state) {
  return {
    portalId: state.portalId
  };
})(FreemiumBookingUpgradeLink);

exports.default = _default;
module.exports = exports.default;